<app-page-meta pageTitle="finzy - Investor Dashboard"></app-page-meta>
<div class="dashboard-wrapper">
    <div class="row">
        <div class="col-lg-8 padding-right-0">
            <section class="main-section">
                <div [ngClass]="expandRoi == true ? 'interest-card-with-details': ''">
                    <article class="interest-card-wrapper">
                        <div class="roi-details">
                            <img class="roi-icon" alt="return of interest"
                                src="../../../../../../assets/images/finzy-flex/returnOfInterest.svg" />
                            <span appDottedLoader [appShowLoaderUntil]="lenderAccountInfo?.roi" class="roi-figure">
                                <span *ngIf="lenderAccountInfo?.roi;">
                                  {{ (lenderAccountInfo?.roi || 0) | number : "1.0-2" }} % p.a
                                </span>
                                <span *ngIf="lenderAccountInfo?.roi === 0.0">
                                  {{ lenderAccountInfo?.roi || 0 | number : "1.0-2" }} % p.a
                                </span>
                            </span>

                            <div class="roi-flex">
                                <span class="roi-label">Interest</span>
                                <span *ngIf="!expandRoi" (click)="onExpand('expandRoi')" class="view-less align-right">
                                    View More
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </span>
                                <span *ngIf="expandRoi" (click)="onCollapse('expandRoi')" class="view-less align-right">
                                    View Less
                                    <i class="fa fa-angle-up" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <div class="roi-image">
                            <img alt="dashboard image" height="200px" width="auto"
                                src="../../../../../../assets/gif/finzy-flex/dashboard.svg" />
                        </div>
                    </article>
                    <article *ngIf="expandRoi">
                        <app-expanded-products 
                            [productList]="roiDetails" 
                            [productVariant]="lenderAccountInfo?.products"
                            [backgroundColor]="'#f9f9f9'"
                            [expansionFor]="'expandRoi'" 
                            (collapseItem)="onCollapse($event)">
                        </app-expanded-products>
                    </article>
                </div>
                <article class="medium-cards-wrapper">
                    <div class="grouping-cards">
                        <div class="two-cards">
                            <div class="medium-cards light-green">
                                <img class="principal-outstanding" alt="principal outstanding" src="../../../../../../assets/images/finzy-flex/principal-outstanding.svg" />
                                <span appDottedLoader [appShowLoaderUntil]="lenderAccountInfo?.principalOutstanding" class="outstanding-amt">
                                    <ng-container *ngIf="lenderAccountInfo?.principalOutstanding"> 
                                        <span  class="light-money">&#8377;</span>{{(preciseNumber(lenderAccountInfo?.principalOutstanding) || 0.0) | currency: 'INR': ''}}
                                    </ng-container>
                                    <ng-container *ngIf="lenderAccountInfo?.principalOutstanding === 0.0">
                                        <span  class="light-money">&#8377;</span>{{(preciseNumber(lenderAccountInfo?.principalOutstanding) || 0.0) | currency: 'INR': ''}}
                                    </ng-container>
                                </span>

                                <span class="outstanding-label">Principal Outstanding</span>
                                <span *ngIf="!expandPrincipalOutstanding"
                                    (click)="onExpand('expandPrincipalOutstanding')" class="view-less">
                                    View More
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </span>
                                <span *ngIf="expandPrincipalOutstanding"
                                    (click)="onCollapse('expandPrincipalOutstanding')" class="view-less">
                                    View Less
                                    <i class="fa fa-angle-up" aria-hidden="true"></i>
                                </span>
                            </div>
                            <div class="medium-cards light-yellow">
                                <img class="principal-outstanding" alt="principal outstanding" src="../../../../../../assets/images/finzy-flex/interest-earned.svg" />
                                <span appDottedLoader [appShowLoaderUntil]="lenderAccountInfo?.interestAmount" class="outstanding-amt">
                                    <ng-container *ngIf="lenderAccountInfo?.interestAmount;">
                                        <span  class="light-money">&#8377;</span>{{(lenderAccountInfo?.interestAmount || 0.0) | currency:'INR': ''}}
                                    </ng-container>
                                    <ng-container *ngIf="lenderAccountInfo?.interestAmount === 0.0">
                                        <span  class="light-money">&#8377;</span>{{(lenderAccountInfo?.interestAmount || 0.0) | currency:'INR': ''}}
                                    </ng-container>
                                </span>
                                <span class="outstanding-label">Interest Earned</span>
                                <span *ngIf="!expandInterestEarned" (click)="onExpand('expandInterestEarned')"
                                    class="view-less">
                                    View More
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </span>
                                <span *ngIf="expandInterestEarned" (click)="onCollapse('expandInterestEarned')"
                                    class="view-less">
                                    View Less
                                    <i class="fa fa-angle-up" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <div class="wrap-for-sm" *ngIf="expandPrincipalOutstanding || expandInterestEarned">
                            <article class="down-triangle-group">
                                <div class="down-triangle">
                                    <i *ngIf="expandPrincipalOutstanding" class="fa fa-sort-down font-icon"></i>
                                </div>
                                <div class="down-triangle">
                                    <i *ngIf="expandInterestEarned" class="fa fa-sort-down font-icon"></i>
                                </div>
                            </article>
                            <article class="light-green bor-rad" *ngIf="expandPrincipalOutstanding">
                                <app-expanded-products 
                                    [productList]="principalOutStandingDetails"
                                    [productVariant]="lenderAccountInfo?.products"
                                    [backgroundColor]="'#edffed'" 
                                    [expansionFor]="'expandPrincipalOutstanding'"
                                    (collapseItem)="onCollapse($event)">
                                </app-expanded-products>
                            </article>
                            <article class="light-yellow bor-rad" *ngIf="expandInterestEarned">
                                <app-expanded-products 
                                    [productList]="interestEarnedDetails"
                                    [productVariant]="lenderAccountInfo?.products"
                                    [backgroundColor]="'#fffdf5'" 
                                    [expansionFor]="'expandInterestEarned'"
                                    (collapseItem)="onCollapse($event)">
                                </app-expanded-products>
                            </article>
                        </div>
                    </div>
                    <div class="medium-cards light-blue">
                        <img class="principal-outstanding" alt="principal outstanding" src="../../../../../../assets/images/finzy-flex/n-cash.svg" />
                        <span appDottedLoader [appShowLoaderUntil]="nCashAmountToShow" class="outstanding-amt">
                            <ng-container *ngIf="nCashAmountToShow">
                                <span  class="light-money">&#8377;</span>{{ (nCashAmountToShow || 0.0) | currency:'INR': ''}}
                            </ng-container>
                            <ng-container *ngIf="nCashAmountToShow === 0">
                                <span  class="light-money">&#8377;</span>{{ (nCashAmountToShow || 0.0) | currency:'INR': ''}}
                            </ng-container>
                        </span>
                        <div class="date-and-text" *ngIf="nCashDate">
                            <span class="outstanding-label">nCash on {{ nCashDate }}</span>
                            <span *ngIf="nCashDate" class="view-more" (click)="navigateToPreferences()">
                                Change
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="flex-column" *ngIf="!nCashDate">
                            <span class="outstanding-label">Set up nCash</span>
                            <span class="view-more" (click)="navigateToPreferences()">
                                Set up
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                </article>
                <article *ngIf="expandPrincipalOutstanding || expandInterestEarned"
                    class="down-triangle-group expansion-portion">
                    <div class="down-triangle">
                        <i *ngIf="expandPrincipalOutstanding" class="fa fa-sort-down font-icon"></i>
                    </div>
                    <div class="down-triangle">
                        <i *ngIf="expandInterestEarned" class="fa fa-sort-down font-icon"></i>
                    </div>
                    <div class="down-triangle"></div>
                </article>
                <article class="light-green bor-rad expansion-portion" *ngIf="expandPrincipalOutstanding">
                    <app-expanded-products 
                        [productList]="principalOutStandingDetails" 
                        [productVariant]="lenderAccountInfo?.products"
                        [backgroundColor]="'#edffed'"
                        [expansionFor]="'expandPrincipalOutstanding'" 
                        (collapseItem)="onCollapse($event)">
                    </app-expanded-products>
                </article>
                <article class="light-yellow bor-rad expansion-portion" *ngIf="expandInterestEarned">
                    <app-expanded-products 
                        [productList]="interestEarnedDetails" 
                        [productVariant]="lenderAccountInfo?.products"
                        [backgroundColor]="'#fffdf5'"
                        [expansionFor]="'expandInterestEarned'" 
                        (collapseItem)="onCollapse($event)">
                    </app-expanded-products>
                </article>
                <article class="invest-now">
                    <div class="invest-text-wrapper">
                        <h3 class="invest-heading">Investment</h3>
                        <span class="invest-info">
                            finzyFLEX offers flexible investment options and returns up to 12% p.a. Start your
                            investment journey now!
                            <strong> <a href="/faq?selectedTab=FINZY_FLEX" target="_blank" style="color: #fff;"> Read
                                    more </a></strong>
                        </span>
                    </div>
                    <div class="invest-btn-wrapper">
                        <button [disabled]="isSwiftOn" (click)="onClickInvestNow()" class="invest-btn">Invest
                            Now</button>
                    </div>
                </article>
                <article class="investment-section-wrapper">
                    <div class="investment-header">
                        <span class="investment-text">
                            finzyFLEX Investment Options
                        </span>
                    </div>
                    <div class="investment-options-wrapper">
                        <span appDottedLoader [appShowLoaderUntil]="investmentOptions" class="outstanding-amt">
                            <ng-container *ngIf="investmentOptions">
                                <app-investment-options [investmentOptions]="investmentOptions"></app-investment-options>
                            </ng-container>
                        </span>
                    </div>
                </article>
            </section>
        </div>
        <div class="col-lg-4">
            <section class="side-section">
                <article class="wallet-details">
                    <div class="wallet-info-section">
                        <div class="left-portion">
                            <h2 class="wallet-header">
                                Wallet
                            </h2>
                            <span class="wallet-description">
                                Available Funds
                            </span>
                        </div>
                        <div class="right-portion">
                            <span class="wallet-balance">
                                Wallet Balance:
                            </span>
                            <span class="wallet-amt">
                                <span appDottedLoader [appShowLoaderUntil]="lenderBasicInfo?.walletAmount">
                                    <ng-container *ngIf="lenderBasicInfo?.walletAmount">
                                    <app-indian-currency-formatter [amount]="lenderBasicInfo?.walletAmount"></app-indian-currency-formatter>
                                    </ng-container>
                                    <ng-container *ngIf="lenderBasicInfo?.walletAmount === 0.0">
                                        <app-indian-currency-formatter [amount]="lenderBasicInfo?.walletAmount"></app-indian-currency-formatter>
                                    </ng-container>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="wallet-btn-section">
                        <button (click)="onAddFunds()" class="add-funds">Add Fund To Wallet</button>
                    </div>
                </article>

                <article class="investment-withdraw">
                    <div class="withdraw-heading-portion">
                        <span class="withdraw-title">
                            Liquidate Investments
                        </span>
                        <span class="withdraw-description">
                            Liquidate your investments post Minimum Holding Period (MHP)
                        </span>
                        <br/><br/>
                        <div class="withdraw-amt-details">
                            <span class="withdraw-amt-title">
                                Total withdrawable amount:
                                <app-tooltip placement="bottom">
                                    <i class="info-icon material-icons" trigger>info_outline</i>
                                    <div content style="max-width: 300px;">Amount available to withdraw post completion
                                        of Minimum Holding Period.
                                        Click on <strong>“Withdraw”</strong> to choose the amount you wish to redeem to
                                        your bank account.
                                    </div>
                                </app-tooltip>
                            </span>
                            <span class="withdraw-amt">
                                <span appDottedLoader [appShowLoaderUntil]="lenderAccountInfo?.withdrawBackMoney">
                                    <ng-container *ngIf="lenderAccountInfo?.withdrawBackMoney">
                                        <span  class="light-money small-money-font">&#8377;</span>{{(preciseNumber(lenderAccountInfo?.withdrawBackMoney) || 0.0) | currency:'INR': ''}}
                                    </ng-container>
                                    <ng-container *ngIf="lenderAccountInfo?.withdrawBackMoney === 0.0">
                                        <span  class="light-money small-money-font">&#8377;</span>{{(preciseNumber(lenderAccountInfo?.withdrawBackMoney) || 0.0) | currency:'INR': ''}}
                                    </ng-container>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="withdraw-btn-section">
                        <button class="withdraw-btn" [disabled]="isDisableWithdrawalNowButton()" (click)="onWithdrawFunds()">Withdraw Now
                            <ng-container *ngIf="withdrawalButtonHelperText">
                                <app-tooltip placement="bottom">
                                    <i class="info-icon material-icons" trigger>info_outline</i>
                                    <div content style="max-width: 300px;">{{withdrawalButtonHelperText}}.</div>
                                </app-tooltip>
                            </ng-container>
                        </button>
                    </div>
                </article>
            </section>
        </div>
    </div>
    <div class="row show-in-tab">
        <div class="col-lg-7">
            <section>
                <app-quick-setup 
                    [isSwiftOn]="isSwiftOn" 
                    [isNCashOn]="isNCashOn"
                    [userAttributes]="preferences">
                </app-quick-setup>
            </section>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-7">
            <article class="text-details-info">
                <p class="text-details-heading">
                    Additional terms for finzyFLEX to be read along with and in addition to
                    <a href="/terms?selectedTab=INVESTOR" target="_blank">Investor Terms</a>
                </p>
                <ul class="text-details-wrapper">
                    <li><span class="text-details">Bridge Fintech (Finzy) will earn differential in interest between the
                            interest rate paid by the borrower and Investor Interest Rate. Bridge Fintech (Finzy) will
                            not
                            earn such income, if such interest differential is zero or is negative</span>
                    </li>
                    <li><span class="text-details">Bridge Fintech (Finzy) does not guarantee any rate of return or
                            return of principal. Investments made herein are subject to credit risk and performance
                            of the underlying loans.</span>
                    </li>
                    <li><span class="text-details">Investor Interest Rate referred herein is simple interest rate and is
                            indicative. Such interest amount will be paid either on periodic basis or upon
                            withdrawal.</span>
                    </li>
                    <li><span class="text-details">Periodic payouts and Withdrawal proceeds are offered on best effort
                            basis.
                            Such proceeds will be paid by assignment of investor's outstanding loans to another investor
                            or from
                            accumulated return of an Investor. Under normal circumstances, you should expect funds in
                            your bank
                            account within 7 days from the withdrawal request.</span>
                    </li>
                    <li><span class="text-details">Allocation of new investments and reinvestment on repayments under
                            finzyFLEX will happen through auto investment mode. Investor might have an option to reverse
                            any
                            allocation into a loan for a limited time period. Any reversal request will not be allowed
                            post
                            expiry of this time period.</span>
                    </li>
                    <li><span class="text-details">Bridge Fintech (Finzy) may decide on timing of investment in loan and
                            change the auto allocation preferences (if any) from time to time.</span>
                    </li>
                    <li><span class="text-details">Changes to SWIFT and nCash preferences and any Withdrawal request
                            must be
                            made only through the investor dashboard on <span style="color: #000;">www.finzy.com</span>
                            . Setup or changes to nCash preferences
                            may be effective from the following cashflow period.</span>
                    </li>
                    <li><span class="text-details">Interest calculation would be on actual/365 day count convention
                            basis.
                            If payout date happens to be a banking holiday, payouts will be made on the next bank
                            working day.
                            For working day and banking days, we shall follow RBI Holiday calendar for Mumbai.</span>
                    </li>
                    <li><span class="text-details">Finzy reserves the right to withdraw any product offering or its
                            variant
                            or change the terms of product offering without any notice.</span>
                    </li>
                </ul>
                <p class="text-details">
                    Please refer to
                    <a href="/faq?selectedTab=FINZY_FLEX" target="_blank">finzyFLEX FAQs</a>
                    for more detailed information or reach out to us at
                    <a href="mailto:support@finzy.com" target="_blank" style="color: #000;">support@finzy.com</a>.
                </p>
            </article>
        </div>
    </div>
</div>